import { useEffect, useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

export const useImpressionEvent = (event?: (payload?: Record<string, unknown>) => void, threshold = 0.6) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold,
  });
  const alreadySentEventRef = useRef<boolean>(false);

  useEffect(() => {
    if (isIntersecting && !alreadySentEventRef.current) {
      event?.();
      alreadySentEventRef.current = true;
    }
  }, [event, isIntersecting, alreadySentEventRef.current]);

  return ref;
};
